import { Link, useHref } from 'react-router-dom';
import { StyledListItem } from './ListItem.Styles';

const ListItem = (props) => {
  const { item, href, Icon } = props;

  const active = useHref() === `/${href}`;
  const activeIconColor = '#a3a0fb';
  const inactiveIconColor = '#A5A4BF';

  return (
    <Link to={href} style={{ textDecoration: 'none' }}>
      <StyledListItem border={useHref() === `/${href}`} active={active}>
        <Icon htmlColor={active ? activeIconColor : inactiveIconColor} />
        <span style={{ color: '#ffffff' }}>{item}</span>
      </StyledListItem>
    </Link>
  );
};

export default ListItem;
